import { render } from "./RequestOverview.vue?vue&type=template&id=500e6257&scoped=true"
import script from "./RequestOverview.vue?vue&type=script&lang=js"
export * from "./RequestOverview.vue?vue&type=script&lang=js"

import "./RequestOverview.vue?vue&type=style&index=0&id=500e6257&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\divindenduitkering_toets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500e6257"]])

export default __exports__